export default function ResourcesPage() {
  return (
    <div className="max-w-6xl mx-auto px-6 pt-8 pb-16">
      <section className="mb-10">
        <h1 className="text-2xl font-extrabold text-text-primary mb-2">资源中心</h1>
        <p className="text-text-secondary text-sm">新闻动态、赛事图集、技术文档与资料下载</p>
      </section>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-10">
        {/* News */}
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-base font-extrabold text-text-primary">最新动态</h2>
            <span className="text-xs text-arena-blue hover:underline cursor-pointer">更多</span>
          </div>
          <div className="space-y-4">
            {[
              { d: '2026-07-28', t: '产品方案 v0.4 发布——结构设计决策全部确认', tag: '产品' },
              { d: '2026-07-25', t: '文古小学定制方案完成，进入交付阶段', tag: '合作' },
              { d: '2026-07-20', t: '四档主板硬件选型确定，硬件成本锁定', tag: '硬件' },
              { d: '2026-07-15', t: '竞技规则手册 v0.4——三级赛制体系完善', tag: '赛事' },
              { d: '2026-07-10', t: '团队赛规则补充方案——2v2 战术维度设计完成', tag: '赛事' },
            ].map((n) => (
              <div key={n.d} className="flex items-start gap-3 pb-4 border-b border-border-dark/50 last:border-0 last:pb-0">
                <span className="text-[11px] font-mono text-text-disabled w-20 shrink-0 pt-0.5">{n.d}</span>
                <div className="flex-1 min-w-0">
                  <p className="text-sm text-text-primary hover:text-arena-blue cursor-pointer transition-colors">{n.t}</p>
                  <span className="text-[10px] px-1.5 py-0.5 rounded-tag bg-border-dark text-text-disabled mt-1.5 inline-block">{n.tag}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Gallery placeholder */}
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-base font-extrabold text-text-primary">赛事图集</h2>
            <span className="text-xs text-arena-blue hover:underline cursor-pointer">更多</span>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-square rounded-card mecha-card mecha-bolt bg-panel-mid/40 border border-border-dark flex items-center justify-center hover:border-arena-blue/40 transition-all cursor-pointer">
                <div className="text-center">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#4A5560" strokeWidth="1.5" className="mx-auto mb-1"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
                  <span className="text-[10px] text-text-disabled">待上传</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-10">
        {/* Downloads */}
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          <h2 className="text-base font-extrabold text-text-primary mb-5">资料下载</h2>
          <div className="space-y-3">
            {[
              { n: '产品规格书 v0.4', t: 'PDF', s: '2.3 MB' },
              { n: '竞技规则手册 v0.4', t: 'PDF', s: '1.8 MB' },
              { n: '教师教学指南 v0.4', t: 'PDF', s: '4.1 MB' },
              { n: '3D 打印参数参考', t: 'PDF', s: '0.8 MB' },
              { n: 'A 板固件 SDK', t: 'ZIP', s: '5.6 MB' },
            ].map((d) => (
              <div key={d.n} className="flex items-center gap-3 p-2 rounded hover:bg-panel-mid/40 transition-colors cursor-pointer">
                <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded-tag ${d.t === 'PDF' ? 'bg-arena-red/15 text-arena-red' : 'bg-arena-blue/15 text-arena-blue'}`}>{d.t}</span>
                <span className="text-xs text-text-secondary flex-1">{d.n}</span>
                <span className="text-[10px] text-text-disabled">{d.s}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Videos */}
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          <h2 className="text-base font-extrabold text-text-primary mb-5">视频中心</h2>
          <div className="space-y-3">
            {['产品拼装演示', '对抗赛精彩集锦', '编程入门教程', '3D 打印改装指南'].map((v) => (
              <div key={v} className="flex items-center gap-3 p-2 rounded hover:bg-panel-mid/40 transition-colors cursor-pointer">
                <div className="w-16 h-10 rounded bg-panel-mid/40 border border-border-dark flex items-center justify-center shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="#4A5560" stroke="none"><polygon points="5,3 19,12 5,21"/></svg>
                </div>
                <span className="text-xs text-text-secondary">{v}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Announcements */}
        <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6">
          <h2 className="text-base font-extrabold text-text-primary mb-5">公告</h2>
          <div className="space-y-3">
            {[
              { d: '07-28', t: '2026 秋季赛季报名即将开放', c: 'text-arena-green' },
              { d: '07-20', t: '官方裁判系统固件升级通知', c: 'text-arena-blue' },
              { d: '07-15', t: '华南区校园联赛赛程调整公告', c: 'text-warning-orange' },
              { d: '07-01', t: '3D 模型库审核标准更新', c: 'text-text-secondary' },
            ].map((a) => (
              <div key={a.t} className="flex items-start gap-2 pb-3 border-b border-border-dark/50 last:border-0 last:pb-0">
                <span className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${a.c}`} style={{ backgroundColor: a.c === 'text-arena-green' ? '#00E676' : a.c === 'text-arena-blue' ? '#00C2FF' : a.c === 'text-warning-orange' ? '#FF6D00' : '#88929E' }} />
                <div>
                  <p className="text-xs text-text-secondary hover:text-text-primary cursor-pointer transition-colors">{a.t}</p>
                  <span className="text-[10px] text-text-disabled">{a.d}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
